module.exports = __webpack_public_path__ + "img/lift_logo.0be0ba52.svg";